/*
 * HomePage
 *
 * This is the first page users see of our App, at the '/' route
 */

import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Search from './Search/Search';
import SearchResult from './SearchResult';
import NotificationBar from '../../components/Notification/NotificationBar';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ErrorBoundary from '../../components/ErrorBoundary'
import Image from '../../assets/images/HomePage/information.gif';

import {
    changeSearchStatus,
    booklistUpdate,
} from '../../modules/user';

class HomePage extends Component {

    static propTypes = {
        searchStatus: PropTypes.string.isRequired,
        changeSearchStatus: PropTypes.func.isRequired,
        booklistUpdate: PropTypes.func.isRequired,
        bookGenres: PropTypes.array.isRequired,
        challengeLevels: PropTypes.array,
        logonEnabled:  PropTypes.string,
    };

    render () {
        const {
            changeSearchStatus,
            booklistUpdate,
            bookGenres,
            searchStatus,
            challengeLevels,
            logonEnabled,

        } = this.props;

        return ([

            <div className="challenge_information_div">
                {(logonEnabled[0] == "false") ?
                <div>
                <img src={Image}/>
                <span className="challenge_information">
                 {logonEnabled[2]}
                </span></div> : ''}
            </div>,

            <div className="home-page">
                <Helmet>
                    <title>Home Page: NSW Premier's Reading Challenge</title>
                    <meta name="description" content="Home page"/>
                </Helmet>
                <ErrorBoundary>
                    <NotificationBar />
                    <Search
                        changeSearchStatus={changeSearchStatus}
                        searchStatus={searchStatus}
                        booklistUpdate={booklistUpdate}
                        bookGenres={bookGenres}
                        challengeLevels={challengeLevels}
                    />
                </ErrorBoundary>
                {(searchStatus === 'selectComplete' || searchStatus === 'inputComplete') ?
                    <ErrorBoundary>
                        <SearchResult
                            isInputSearch={searchStatus === 'inputComplete'}
                        />
                    </ErrorBoundary> : ''}
            </div>
        ]);
    }
}


const mapStateToProps = state => {
    return ({
        searchStatus: state.user.searchStatus,
        bookGenres: state.user.bookGenres,
        challengeLevels: state.user.challengeLevels,
        logonEnabled: state.user.logonEnabled,
    });
}

const mapDispatchToProps = dispatch => bindActionCreators({
    changeSearchStatus,
    booklistUpdate,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(HomePage);

